import Typography from '@mui/material/Typography'
import React from 'react'
import {TemporaryToggle} from '../../UserManagement/UserManagementStyle'
import PropTypes from 'prop-types'
import {Grid} from '@mui/material'
import {HealthConditionSubTitle} from '../HealthCondition/HealthConditionStyle'
import {ChatbotCopyWrapper, ToggleStack} from './ChatbotCopyStyle'

const ChatbotExport = ({selectedExport, setSelectedExport, disabled}) => {
  const setSelectedToggleFunction = () => {
    setSelectedExport([1 - selectedExport[0]])
  }

  React.useEffect(() => {
    if (disabled) {
      setSelectedExport([0])
    }
  }, [disabled, setSelectedExport])

  return (
    <ChatbotCopyWrapper tabIndex={0} aria-label='Agent Export'>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <HealthConditionSubTitle>Export functionality in Agent</HealthConditionSubTitle>
        </Grid>
        <Grid item xs={12} md={6}>
          <ToggleStack>
            <Typography>Off</Typography>
            <TemporaryToggle
              data-testid='assistant-export-toggle'
              checked={selectedExport?.length > 0 ? selectedExport[0] : false}
              onChange={setSelectedToggleFunction}
              aria-label='Agent Export Toggle Button'
              disabled={!!(disabled === undefined ? false : disabled)}
            />
            <Typography>On</Typography>
          </ToggleStack>
        </Grid>
      </Grid>
    </ChatbotCopyWrapper>
  )
}

ChatbotExport.propTypes = {
  setSelectedExport: PropTypes.func,
  selectedExport: PropTypes.array,
  disabled: PropTypes.bool
}

export default ChatbotExport
